<template>
  <div>
    <com-page>
      <com-search :columns="searchColumn" @search="handleSearch"></com-search>
      <com-card class="mt-15px">
        <div class="flex items-start mb-5px">
          <h4 class="mt-12px">订单状态</h4>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.value"
              v-for="item in statusTag"
              :key="item.value"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <com-table ref="table" :api="api" :columns="columns"  :defaultParams="defaultParams">
          <template #deviceType="{ data }">
            {{ deviceTypeMap[data.deviceType] }}
          </template>
          <template #status="{ data }">
            {{ orderStatus[data.status] }}
          </template>
          <template #startTime="{ data }">
            {{ data.startTime | timeFormate }}
          </template>
          <template #endTime="{ data }">
            {{ data.endTime | timeFormate }}
          </template>
          <template #operation="row">
            <div>
              <el-button type="primary" size="mini" @click="handleDetail(row.data)">详情</el-button>
              <el-button v-if="row.data.status === 1" type="warning" size="mini" @click="releaseOccupancy(row.data)">解除占用</el-button>
              <el-button
                v-if="row.data.status === 2"
                type="warning"
                size="mini"
                @click="openRefundDialog(row.data)"
                >退款</el-button
              >
            </div>
          </template>
        </com-table>

        <com-dialog :visible.sync="dialogVisible" title="退款" width="40%">
          <div>
            <div>
              <span>订单 {{ orderItemData.number }}</span>
              <span class="ml-15px"> 实付金额 {{orderItemData.paySum }} </span>
            </div>
            <div class="flex items-center mt-15px">
              <div>退款金额：</div>
              <el-input
                style="width: 300px;"
                placeholder="请输入退款金额"
                v-model="refundSum"
              ></el-input>
            </div>
            <div class="flex items-center mt-15px">
              <div>退款原因：</div>
              <el-input
                style="width: 300px;"
                placeholder="请输入退款原因"
                v-model="refundReason"
              ></el-input>
            </div>
            <div class="mt-15px flex items-center justify-end">
              <el-button type="" @click="dialogVisible = false">取消</el-button>
              <el-button type="primary" @click="handleRefund">确定</el-button>
            </div>
          </div>
        </com-dialog>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import { timeoutOccupancyOrder, releaseOccupancyApi, refundTimeoutOrder } from '@/api/order'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      api: timeoutOccupancyOrder,
      activeName: '-1',
      statusTag: [
        {
          label: '全部',
          value: '-1'
        },
        {
          label: '进行中',
          value: '1'
        },
        {
          label: '已完成',
          value: '2'
        },
        {
          label: '已退单',
          value: '3'
        }
      ],
      defaultParams: {
        status: ''
      },
      query: {},
      searchColumn: [
        {
          label: '用户ID/手机号',
          prop: 'queryUserCondition',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '充电订单编号',
          prop: 'refChargePieOrderNumber',
          type: 'input'
        },
        {
          label: '网点名称',
          prop: 'refStoreName',
          type: 'input'
        },
      ],
      columns: [
        {
          label: '订单编号',
          prop: 'number',
          width: '130'
        },
        {
          label: '关联充电订单',
          prop: 'refChargePieOrderNumber',
          width: '130'
        },
        {
          label: '网点名称',
          prop: 'refStoreName',
          width: '130'
        },
        {
          label: '设备二维码',
          prop: 'refDevLabel',
          width: '120'
        },
        {
          label: '设备编号',
          prop: 'refDevSn',
          width: '120'
        },
        {
          label: '设备类型',
          prop: 'deviceType',
          type: 'slot',
          slotName: 'deviceType',
          width: '120'
        },
        {
          label: '开始时间',
          prop: 'startTime',
          type: 'slot',
          slotName: 'startTime',
          width: '120'
        },
        {
          label: '结束时间',
          prop: 'endTime',
          type: 'slot',
          slotName: 'endTime',
          width: '120'
        },
        {
          label: '订单时长',
          prop: 'timeoutDuration',
          width: '120'
        },
        {
          label: '订单小计(元)',
          prop: 'sum',
          width: '130'
        },
        {
          label: '实付金额(元)',
          prop: 'paySum',
          width: '130'
        },
        {
          label: '用户ID',
          prop: 'refXdUserNumber',
          width: '120'
        },
        {
          label: '手机号',
          prop: 'refXdUserPhone',
          width: '130'
        },
        {
          label: '订单状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status',
          width: '120'
        },
        {
          label: '操作',
          prop: 'operation',
          fixed: 'right',
          type: 'slot',
          slotName: 'operation',
          width: '180'
        }
      ],
      deviceTypeMap: {
        1: '电动车充电桩',
        2: '充电柜',
        3: '汽车充电桩'
      },
      orderStatus: {
        1: '进行中',
        2: '已完成'
      },
      dialogVisible: false,
      orderItemData: {},
      refundSum: '',
      refundReason: ''
    }
  },
  methods: {
    handleClick() {
      this.defaultParams.status = +this.activeName === -1 ? '' : +this.activeName
      this.$refs.table.init()
    },

    handleSearch(val) {
      this.query = val
      this.$refs.table.search(val)
    },

    handleDetail(row) {
      // 跳转详情
      this.$router.push({ path: 'timeout-order-detail', query: { code: row.code} })
    },

    releaseOccupancy(row) {
      this.$confirm(`确认解除订单${row.number}的占用？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        releaseOccupancyApi(row).then((res) => {
          this.$message.success('操作成功，可稍等几秒刷新列表')
          this.$refs.table.getList()
        })
      })
    },

    openRefundDialog(row) {
      this.refundSum = ''
      this.refundReason = ''
      this.orderItemData = utils.deepCopy(row)
      this.dialogVisible = true
      console.log('退款 :>> ', this.orderItemData)
    },

    // 退款
    async handleRefund() {
      const params = {
        code: this.orderItemData.code,
        refundSum: this.refundSum,
        reason: this.refundReason
      }
      const res = await refundTimeoutOrder(params)
      if (res.status === 200) {
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.$refs.table.init()
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
